import { TemperatureRange } from "@/models/wine";

export function toReadableTemperature(range: TemperatureRange): string {
	return `${parseInt(range.min, 10)} - ${parseInt(range.max, 10)} °C`;
}
